var menu = document.getElementById('menu');
var menubtn = document.getElementById('menubtn');
function abrirMenu(v){
  menu.classList.toggle('on', v);
  document.body.classList.toggle('menu-open', v);
  menubtn.setAttribute('aria-expanded', v ? 'true' : 'false');
  if (v) document.getElementById('menuclose').focus(); else menubtn.focus();
}
menubtn.addEventListener('click', function(){ abrirMenu(true); });
document.getElementById('menuclose').addEventListener('click', function(){ abrirMenu(false); });
document.addEventListener('keydown', function(e){ if(e.key==='Escape' && menu.classList.contains('on')) abrirMenu(false); });
function setLang(l){
  document.documentElement.lang=l;
  document.querySelectorAll('[data-'+l+']').forEach(function(e){e.innerHTML=e.getAttribute('data-'+l)});
  document.querySelectorAll('.lang button').forEach(function(b){b.classList.toggle('on',b.dataset.lang===l)});
  try{localStorage.setItem('mess-lang',l)}catch(e){}
}
document.querySelectorAll('.lang button').forEach(function(b){b.onclick=function(){setLang(b.dataset.lang)}});
try{var sv=localStorage.getItem('mess-lang'); if(sv==='en')setLang('en')}catch(e){}